export default __webpack_public_path__ + "./fonts/radioCheckedAnswer.9d238495.svg";